var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('Map'),_c('MyNav',{ref:"MyNav"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }